<template>
  <div class="app">
    <TopLogoImages />
    <div class="content">
      <NavigationBar />
      <router-view />
    </div>
    <BottomLogoImages />
  </div>
</template>

<script>
import TopLogoImages from './components/Top-LogoImages.vue';
import BottomLogoImages from './components/Bottom-LogoImages.vue';
import NavigationBar from './components/Navigation-bar.vue';
export default{
  components:{
    TopLogoImages,
    BottomLogoImages,
    NavigationBar
  }
}
</script>

<style scoped>
html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

.app {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.content {
  flex-grow: 1; /* 内容区域自动扩展，占满剩余空间 */
}

.bottom-logo {
  width: 100%;
  /* BottomLogoImages 会自动出现在页面底部 */
}
</style>